<template lang="pug">
label.relative.inline-flex.cursor-pointer.items-center
  input.peer.sr-only(:checked="modelValue" @change="onChange" type="checkbox")
  .peer.rounded-full.bg-gray-600.dark_bg-gray-600.peer-checked_after_translate-x-full.peer-checked_after_border-white.after_absolute.after_bg-white.after_border-gray-300.after_border.after_rounded-full.after_transition-all.dark_border-gray-600.peer-checked_bg-blue-700.after_top-0.after_left-0.peer-focus-visible_focus-ring(
    class="h-[1em] w-[2em] after_h-[1em] after_w-[1em] after_content-[''] after_scale-[0.8]"
  )
</template>

<script lang="ts" setup>
defineProps<{ modelValue: boolean }>();
const emit = defineEmits(['update:modelValue']);

const onChange = (e: MouseEvent) => {
  emit('update:modelValue', (e.target as HTMLInputElement).checked);
};
</script>
